'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["placeholderText", "placeholderType", "placeholderClassName", "error", "config", "renderPlaceholder"];
import PropTypes from 'prop-types';
import { Component, Fragment } from 'react';
import { AppProvider } from 'foundations-components/components/AppProvider';
import styled from 'styled-components';
import TinyMCEHooks from './Components/TinyMCEHooks';
import Placeholder from './Components/Placeholder';
import { PLACEHOLDER_TYPE_CONTENT, PLACEHOLDER_TYPE_FOCUS } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InlineWrapper = styled.div.withConfig({
  displayName: "js__InlineWrapper",
  componentId: "sc-1pn179y-0"
})(({
  $error,
  theme
}) => {
  if ($error) {
    return `
      .mce-content-body {
        border-color: ${theme.color['border-alert-default']};
        box-shadow: 0 0 0 1px ${theme.color['border-alert-default']};
      }
    `;
  }
});
class TinyMceContainer extends Component {
  constructor(props) {
    super(props);
    this.setPlaceholderMinHeight = () => {
      if (!this.props.target || this.props.config.min_height) {
        return;
      }
      if (!this.state.showPlaceholder) {
        this.props.target.style.minHeight = '';
        return;
      }
      this.props.target.style.minHeight = '4rem';
    };
    this.handleInit = (_event, editor) => {
      this.editor = editor;
    };
    this.handleFocus = (event, editor) => {
      this.setShowPlaceholder(editor, false);
      if (this.props.onFocus) {
        this.props.onFocus(event, editor);
      }
    };
    this.handleBlur = (event, editor) => {
      this.setShowPlaceholder(editor, true);
      if (this.props.onBlur) {
        this.props.onBlur(event, editor);
      }
    };
    this.handleKeyDown = event => {
      if (!this.props.isMultiline && event.keyCode === 13) {
        event.preventDefault();
      }
    };
    this.handleSetContent = (__event, editor) => {
      if (!editor.hasFocus()) {
        this.setShowPlaceholder(editor, true);
      }
    };
    this.state = {
      showPlaceholder: false
    };
  }
  componentDidMount() {
    const showPlaceholder = Boolean((this.props.placeholderText || this.props.renderPlaceholder) && !this.props.content);
    this.setState({
      showPlaceholder
    }, this.setPlaceholderMinHeight);
  }
  setShowPlaceholder(editor, didBlur) {
    const shouldShowPlaceholder = editor.getContent() === '' && didBlur;
    if (shouldShowPlaceholder !== this.state.showPlaceholder) {
      this.setState({
        showPlaceholder: shouldShowPlaceholder
      }, this.setPlaceholderMinHeight);
    }
  }
  render() {
    const _this$props = this.props,
      {
        placeholderText,
        placeholderType,
        error,
        config,
        renderPlaceholder
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const {
      showPlaceholder
    } = this.state;
    const placeholderProps = {};
    if (placeholderType === PLACEHOLDER_TYPE_CONTENT && placeholderText) {
      placeholderProps.placeholder = placeholderText;
    }
    const tinymceComponent = config.inline && !this.props.target ? /*#__PURE__*/_jsx(InlineWrapper, {
      $error: error,
      children: /*#__PURE__*/_jsx(TinyMCEHooks, Object.assign({
        config: config
      }, rest, placeholderProps, {
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onKeyDown: this.handleKeyDown,
        onInit: this.handleInit,
        onSetContent: this.handleSetContent
      }))
    }) : /*#__PURE__*/_jsx(TinyMCEHooks, Object.assign({
      config: config
    }, rest, placeholderProps, {
      onBlur: this.handleBlur,
      onFocus: this.handleFocus,
      onKeyDown: this.handleKeyDown,
      onInit: this.handleInit,
      onSetContent: this.handleSetContent
    }));
    if (this.props.target && renderPlaceholder) {
      return /*#__PURE__*/_jsxs(Fragment, {
        children: [showPlaceholder && /*#__PURE__*/_jsx(Placeholder, {
          rootRelative: true,
          renderPlaceholder: renderPlaceholder,
          target: rest.target
        }), tinymceComponent]
      });
    }
    if (placeholderType === PLACEHOLDER_TYPE_FOCUS && renderPlaceholder) {
      return /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          ref: el => {
            this.tinyRoot = el;
          },
          style: {
            position: 'relative',
            outline: 'none'
          },
          children: tinymceComponent
        }), showPlaceholder && /*#__PURE__*/_jsx(Placeholder, {
          target: this.tinyRoot,
          renderPlaceholder: renderPlaceholder
        })]
      });
    }
    return tinymceComponent;
  }
}
TinyMceContainer.defaultProps = {
  isMultiline: true,
  tinyMceRef: () => {},
  placeholderType: PLACEHOLDER_TYPE_FOCUS
};
TinyMceContainer.propTypes = {
  isMultiline: PropTypes.bool,
  placeholderType: PropTypes.oneOf([PLACEHOLDER_TYPE_FOCUS, PLACEHOLDER_TYPE_CONTENT]),
  placeholderText: PropTypes.string,
  placeholderClassName: PropTypes.string,
  tinyMceRef: PropTypes.func,
  renderPlaceholder: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  content: PropTypes.string,
  config: PropTypes.object,
  target: PropTypes.object,
  error: PropTypes.bool
};
const withTrellis = Container => {
  return props => {
    return /*#__PURE__*/_jsx(AppProvider, {
      applyGlobalStyles: false,
      children: /*#__PURE__*/_jsx(Container, Object.assign({}, props))
    });
  };
};
export default withTrellis(TinyMceContainer);